// 用户名脱敏处理函数
export const maskUserName = (userName: string): string => {
  if (!userName) return userName

  if (userName.length >= 3) {
    // 大于等于3个字符：显示首尾字符，中间用星号替换
    const firstChar = userName.charAt(0)
    const lastChar = userName.charAt(userName.length - 1)
    const middleStars = '*'.repeat(userName.length - 2)
    return firstChar + middleStars + lastChar
  } else if (userName.length === 2) {
    // 2个字符：只显示首字符，其他用星号替换
    return userName.charAt(0) + '*'
  } else {
    // 1个字符或空字符串：直接返回
    return userName
  }
}
